import { lerp } from './assets/_utils'
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Scrollbar]) // Swiper宣言

if (document.getElementById('page-business-detail')) {
  // setBusiness()
  setPoints()
  setAchievements()
  setOther()
}

function setBusiness() {
  const elmOverlay = document.querySelector('.businessDetailAbout__overlay')
  const elmBg = document.querySelector('.businessDetailAbout__bg')

  const content = {
    elm: document.querySelector('.businessDetailAbout__content'),
    ratioCurrent: 0, // 現在の変化比率
    ratioTarget: 0, // 目標の変化比率
    scaleCurrent: 0, // 現在のスケール
    scaleMin: 0, // 最小スケール（ループで算出）
    scaleMax: 1, // 最大スケール
    radiusCurrent: 0, // 現在のラディウス(rem)
    radiusMax: 3.2, // 最大ラディウス(rem)
  }

  const inner = {
    elm: document.querySelector('.businessDetailAbout__inner'),
    ratioCurrent: 0, // 現在の変化比率
    ratioTarget: 0, // 目標の変化比率
    paddingTop: 0, // cssで割り当てらている値を代入
  }

  const update = () => {
    const windowH = document.documentElement.clientHeight
    const scrollTop = document.documentElement.scrollTop
    const scrollBottom = scrollTop + windowH

    /**
     * content.elmの上辺が画面下部から上部まで到達するまでを0～1として、elmBgに変化を与える
     */
    // 比率を算出
    const contentTop = content.elm.getBoundingClientRect().top + scrollTop
    content.ratioTarget = ((scrollBottom - contentTop) / windowH).clamp(0, 1)
    content.ratioCurrent = lerp(content.ratioCurrent, content.ratioTarget, 0.2)

    // スケールを算出
    content.scaleMin = 1600 / 1920 // PC用
    content.scaleCurrent = content.scaleMax - (content.scaleMax - content.scaleMin) * (1 - content.ratioCurrent)

    // ラディウスを算出
    const radiusRatio = ((content.ratioCurrent - 0.3) / 0.7).clamp(0, 1) // 少し遅らせる
    content.radiusCurrent = content.radiusMax * (1 - radiusRatio)

    // スタイルを適用
    elmBg.style.transform = `scale(${content.scaleCurrent})`
    elmBg.style.borderRadius = `${content.radiusCurrent}rem`

    /**
     * inner.elmのpadding-top領域を画面下部が通過した割合で、elmOverlayに変化を与える
     */
    // 比率を算出
    const innerTop = inner.elm.getBoundingClientRect().top + scrollTop
    inner.paddingTop = parseFloat(window.getComputedStyle(inner.elm).paddingTop)
    inner.ratioTarget = ((scrollBottom - innerTop) / inner.paddingTop).clamp(0, 1)
    inner.ratioCurrent = lerp(inner.ratioCurrent, inner.ratioTarget, 0.2)

    // スタイルを適用
    elmOverlay.style.opacity = inner.ratioCurrent

    // テキストカラーの変化
    // overlayよりも少し遅らせて適用
    const ratio = ((inner.ratioCurrent - 0.3) / 0.7).clamp(0, 1)
    const c = parseInt('0x10', 16) * (1 - ratio) + parseInt('0xff', 16) * ratio
    // elmSecTitleEn.style.setProperty('--text-default', `rgb(${c},${c},${c})`)
    // elmSecTitleJp.style.color = `rgb(${c},${c},${c})`
    // elmBoxLead.style.color = `rgb(${c},${c},${c})`

    requestAnimationFrame(update)
  }
  update()
}

function setPoints() {
  let swiper = null

  const adjust = () => {
    if (document.documentElement.clientWidth > 768) {
      // PC
      if (!swiper) {
        swiper = new Swiper('.js-points-swiper', {
          loop: false,
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 0,
          centeredSlides: false,

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
      }
    } else {
      // SP
      if (swiper) {
        swiper.destroy(false, true)
        swiper = null
      }
    }
  }

  const mediaQuery = window.matchMedia('(min-width: 768px)')
  mediaQuery.addEventListener('change', adjust)

  adjust()
}

function setAchievements() {
  const swiper01 = new Swiper('.js-achievements-swiper', {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 32,
    centeredSlides: false,

    navigation: {
      nextEl: '.js-achievements-next',
      prevEl: '.js-achievements-prev',
    },

    scrollbar: {
      el: '.js-achievements-scrollbar',
      hide: false,
      draggable: true,
    },

    breakpoints: {
      769: {
        // slidesPerGroup: 4,
        spaceBetween: 48,
      },
    },
  })
}

function setOther() {
  let swiper = null

  const adjust = () => {
    if (document.documentElement.clientWidth > 768) {
      // PC
      if (!swiper) {
        swiper = new Swiper('.js-other-swiper', {
          loop: false,
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 40,
          centeredSlides: false,

          navigation: {
            nextEl: '.js-other-next',
            prevEl: '.js-other-prev',
          },

          scrollbar: {
            el: '.js-other-scrollbar',
            hide: false,
            draggable: true,
          },
        })
      }
    } else {
      // SP
      if (swiper) {
        swiper.destroy(false, true)
        swiper = null
      }
    }
  }

  const mediaQuery = window.matchMedia('(min-width: 768px)')
  mediaQuery.addEventListener('change', adjust)

  adjust()
}
